import axios from 'axios'

const instance = axios.create({
  baseURL: 
  'https://tstatsapi.stats-insight.com/',
  withCredentials: true
})

export const api_authUserLogin = async (payload) => {
  console.log('Get User Login')
  try {
    const { data } = await instance.post('usr/login', payload, { withCredentials: true })
    if (data.status !== undefined) throw Error(data.message)
    return { status: 'success', data }
  } catch (err) {
    console.log(err)
    return { status: 'error', message: err.message }
  }
}

// War Room - Our

export const api_getHighSchoolPlayerRoster = async () => {
  console.log('Get Highschool Player Roster')
  try {
    const { data } = await instance.get('/stat/getHighSchoolPlayerRoster')
    if (data.status !== undefined) throw Error(data.message)
    return { status: 'success', data }
  } catch (err) {
    return { status: 'error', message: err.message }
  }
}

export const api_getHighSchoolLiveCardData = async (payload) => {
  console.log('Get High School Live Card Data')
  try {
    const { data } = await instance.post('/stat/getHighSchoolLiveCard', payload)
    if (data.status !== undefined) throw Error(data.message)
    return { status: 'success', data }
  } catch (err) {
    return { status: 'error', message: err.message }
  }
}

// War Room - ELTA

export const api_getPlayerRoster = async () => {
  console.log('Get CPBL Player Roster')
  try {
    const { data } = await instance.get('/ballsStat/getPlayerRoster')
    if (data.status !== undefined) throw Error(data.message)
    return { status: 'success', data }
  } catch (err) {
    return { status: 'error', message: err.message }
  }
}

export const api_getEltaWarroomData = async (payload) => {
  console.log('Get Elta Warroom Data')
  try {
    const { data } = await instance.post('/stat/getEltaWarroomData', payload)
    if (data.status !== undefined) throw Error(data.message)
    return { status: 'success', data }
  } catch (err) {
    return { status: 'error', message: err.message }
  }
}